<template>
  <tr>
    <td>
      <button @click.prevent.stop="changeQty('-')" :disabled="qty <= 0" type="submit">-</button>
      <input @change.prevent.stop="changeQty" v-model.number="qty" :name="`super_group[${childProduct.product_id}]`" type="number" class="qty"/>
      <button @click.prevent.stop="changeQty('+')" type="submit">+</button>
    </td>
  </tr>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component(
    {
      name: 'catalog-product-grouped-product'
    }
  )
  export default class extends Vue {
    @Prop() private readonly childProduct: object;

    private qty: number = 0;
    private increment: number = 1;

    private get contentValue(): string {
      const regex = RegExp(/\(.*?\)/, 'g');
      let matches, output = [];

      while ((matches = regex.exec(this.childProduct['name'])) != null) {
        output.push(matches[0]);
      }

      return output[output.length - 1].replace(/[()]/g, '');
    }

    private changeQty(a): void {
      if (typeof this.qty !== 'string' && this.qty >= 0) {
        this.qty = a === '+' ? (this.qty + this.increment) : a === '-' && this.qty > 0 ? (this.qty - this.increment) : (Math.ceil(this.qty / this.increment) * this.increment);
      } else {
        this.qty = 0;
      }
      this.$store.dispatch('CatalogGroupedProduct/updateSelectedProduct',
        Object.assign(this.childProduct, {qty: this.qty})
      );
    }

    private async setGalleryImage(id: number): Promise<void> {
      await this.$store.dispatch('CatalogGroupedProduct/slideToGalleryImage', null);
      await this.$store.dispatch('CatalogGroupedProduct/slideToGalleryImage', id);
    }
  }
</script>
